import { render, staticRenderFns } from "./IncorrectAmount.vue?vue&type=template&id=3659d820"
import script from "./IncorrectAmount.vue?vue&type=script&lang=js"
export * from "./IncorrectAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports